/* eslint-disable no-irregular-whitespace */
export default {
  common: {
    scrollToFocus: 'scroll to focus',
    clickPhoto: 'click the photo',
    return: 'return',
    tuneIn: 'tune in',
  },
  IntroRoom: {
    projectName: 'TIME suburbs',
    headphonesOn: 'Please put your headphones on',
    letsGoStartIt: 'Start it',
    instruction: 'Guidelines',
    aboutProject: `"Time Suburbs" is an art research project in which the authors explored the stories of people, lifestyles, and professions, which are likely to disappear in the next century.\n
Today, one of the main trends and perhaps one of the main challenges for modern people is the need to look around and rethink the experience in various human activity manifestations. To stop and look thoughtfully, explore what happened and has been happening. It is necessary because the pace is too wild. With progress, the world changes, information flows increase, animals go extinct, professions disappear, and the new displaces the old. Do we have time to comprehend this process and understand what is becoming a thing of the past every day?\n
Our project’s main characters are mostly people who live in a different time and information space than the inhabitants of big cities.\n
They represent disappearing professions, and it is through their stories that we see old technologies. Through them, we grasp the way of life and thinking, gradually fading into the past. This project attempts to capture and sustain the transition of the modern world to other information and time dimension.\n
The online exhibition uses authentic documentary texts and preserves the original way of speaking of each character.\n
The project was implemented on the territory of Ukraine: Kyiv, Polissia (Perga, Kopyshche, Maidan), Odesa, Carpathians (Vorokhta, Yavoriv, ​​Kosmach, Mykulychyn), Drohobych, Donbas (Toretsk, Shcherbynivka), and Tendrivska Spit. “Time Suburbs” project was created with the support of the Ukrainian Cultural Foundation.
  `,
    guidance: `
  For your experience to be complete, we ask you to \n
  expand the page to full screen and
  put on headphones. \n
  Each chapter is constructed as a story and has its rhythm. \n
  Therefore, we recommend that you watch and listen to the chapter from beginning to end.\n
  However, if you want to linger in the photo or flip, there
  is navigation in the lower right corner of the screen.\n
  Thank you.
  Enjoy.
    `,
  },
  Mobile: {
    part1: 'PROJECT is created for bigger screens',
    part2: 'please, use your laptop with headphones',
    thanks: 'Thank you!',
  },
  lastRoom: {},
}
